import React from "react";
import "../css/DonationReceipt.css";
import jsPDF from "jspdf"
import html2canvas from "html2canvas"


const DonationReceipt = ({ receipt }) => {
  const handleDownloadPDF = async () => {
    const receiptElement = document.getElementById("receipt");
    const canvas = await html2canvas(receiptElement, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
  
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
    // Set margins (e.g., 20mm from top and left)
    const marginLeft = 20; 
    const marginTop = 20;
  
    pdf.addImage(imgData, "PNG", marginLeft, marginTop, pdfWidth - 2 * marginLeft, pdfHeight);
    pdf.save("DonationReceipt.pdf");
  };

  return (
    <div className="receipt-container">
      <div id="receipt">
        <header className="header">
          <h1>श्रीदाजी महाराज संस्थान,टाकळी </h1>
          <p>
            भक्तांनी सहाय्यासाठी हेल्प डेस्कवर संपर्क साधावा: 9529658074.
          </p>
        </header>
        <div className="receipt-content">
          <div className="payment-advice">
            <h2>पेमेंट तपशील</h2>
            <p>
              Phone: 07265 252018, 252251 &nbsp;
            </p>
            <p>
              ई-मेल:{" "}
              <a href="mailto:sansthan@gajananmaharaj.org">
                sansthan@gajananmaharaj.org
              </a>
              &nbsp; | &nbsp; वेबसाइट:{" "}
              <a href="http://www.gajananmaharaj.org">gajananmaharaj.org</a>
            </p>
          </div>
          <div className="details">
            <h3>धन्यवाद!</h3>
            <p>देणगी चा  तपशील क्र: 520803</p>
            <table>
              <tbody>
                <tr>
                  <td>देणगी तारीख:</td>
                  <td>31/12/2024</td>
                </tr>
                <tr>
                  <td>भाविकाचे नाव:</td>
                  <td>कल्याण </td>
                </tr>
                <tr>
                  <td>पत्ता:</td>
                  <td>साई अपार्टमेंट, राजपत नगर , दिल्ली </td>
                </tr>
                <tr>
                  <td>फोन नंबर.:</td>
                  <td>9893934354</td>
                </tr>
                <tr>
                  <td>दान</td>
                  <td>₹31 Rs.</td>
                </tr>
                <tr>
                  <td>देणगी चा प्रकार </td>
                  <td>अभिषेक </td>
                </tr>
              </tbody>
            </table>
          </div>
          <footer className="footer">
            <p>
              <strong>Note:</strong> This is not an official receipt; this is
              only payment advice. <br />
              Official Receipt for the donation shall be sent to you by Shri
              Gajanan Maharaj Sansthan, Shegaon separately by post within 15
              days from the date of donation.
            </p>
          </footer>
        </div>
      </div>
      <button onClick={handleDownloadPDF}>Download PDF</button>
    </div>
  );
};

export default DonationReceipt;
